import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	CenaGdModSzb: null as number | null,
	RabatApSzb: null as number | null,
	RabatGarPzn: null as number | null,
	RabatGarRoz: null as number | null,
	RabatMoSzb: null as number | null,
	RabatNoraSzb: null as number | null,
	RabatRzvSzb: null as number | null,
	RabatSk: null as string | null,
	RabatSkText: null as string | null,
	RabatSzb: null as number | null,
	Text: null as string | null,
	VyrobekndOzn: null as string | null,
	VyrobekndOznText: null as string | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekndOzn: [],
		RabatGarPzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
